export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const TIMEOUT = 50000;
export const PAYMENT_LINK = process.env.REACT_APP_PAYMENT_LINK;
export const ENABLED_PAYMENT = process.env.REACT_APP_ENABLED_PAYMENT === "true";
